// extracted by mini-css-extract-plugin
export var commentLink = "_3x-0";
export var commentProfile = "_3x-1";